module.exports = "//cdn.mxpnl.com/static/asset-cache/682dff1222eff19ec7ff20e4f4c1d222/iron/common/assets/images/charts/logarithmic-bar.svg";